<div class="py-4 container-fluid subjects-page">
  <h4 class="mb-4 subjects-title">การตั้งค่า - รายวิชา</h4>

  <div class="subjects-card">
    <div class="subjects-card-body">
      <div class="subjects-toolbar" [formGroup]="form">
        <div class="subjects-filters">
          <div class="subjects-filter">
            <app-select
              label="เทอมการศึกษา"
              formControlName="academic_term_name"
              [options]="['1', '2', '3']"
              [searchable]="false"
            [clearable]="false"
              inputClass="subjects-select"
              classes="mb-0"
            >
            </app-select>
          </div>

          <div class="subjects-filter">
            <app-select
              label="ปีการศึกษา"
              formControlName="year"
              [options]="yearOptions"
              [searchable]="false"
            [clearable]="false"
              inputClass="subjects-select"
              classes="mb-0"
            >
            </app-select>
          </div>

          <div class="subjects-filter">
            <app-filter-search-input
              label="รหัสวิชา"
              formControlName="code"
              inputClass="subjects-search-input"
              classes="mb-0"
              ariaLabel="ค้นหารหัสวิชา"
              (searchSubmit)="onSearch()"
            ></app-filter-search-input>
          </div>

          <div class="subjects-filter">
            <app-filter-search-input
              label="ชื่อรายวิชา"
              formControlName="name"
              inputClass="subjects-search-input"
              classes="mb-0"
              ariaLabel="ค้นหาชื่อรายวิชา"
              (searchSubmit)="onSearch()"
            ></app-filter-search-input>
          </div>
        </div>

        <div class="subjects-buttons">
          <!-- ENOT hotfix (release 1): Export/Import ยังไม่เปิดใช้งานในเมนูรายวิชา — ซ่อน UI ไว้ก่อน (คงไว้เพื่อเปิดใช้ใน release 2)
          <button
            type="button"
            class="btn btn-outline subjects-outline-button"
            [disabled]="isDownloadingTemplate"
            (click)="onDownloadTemplate()"
          >
            <img src="assets/media/icons/svg/file-down.svg" class="subjects-toolbar-icon" alt="" aria-hidden="true" />
            <span>ดาวน์โหลดแบบฟอร์ม</span>
          </button>

          <button
            type="button"
            class="btn btn-outline subjects-outline-button"
            data-bs-toggle="modal"
            data-bs-target="#subjectsImportDataModal"
            (click)="onImport()"
          >
            <img src="assets/media/icons/svg/file-up.svg" class="subjects-toolbar-icon" alt="" aria-hidden="true" />
            <span>นำเข้าข้อมูล</span>
          </button>
          -->

          <button
            type="button"
            class="btn subjects-add-button"
            [disabled]="!isSelectedTermSynced"
            (click)="onAddSubject()"
          >
            <img src="assets/media/icons/svg/add-item.svg" class="subjects-toolbar-icon" alt="" aria-hidden="true" />
            <span>เพิ่มรายการใหม่</span>
          </button>
        </div>
      </div>

      <ng-template #manualStatusTemplate let-row="row">
        <span class="subjects-manual-status-cell">
          @if (!row.isSynced) {
          <img
            src="assets/media/icons/svg/user-create.svg"
            class="subjects-manual-status-icon"
            alt=""
            aria-hidden="true"
          />
          }
        </span>
      </ng-template>

      <ng-template #rowIndexTemplate let-rowIndex="rowIndex" let-row="row">
        <span class="subjects-index-cell">{{ row.sequence ?? subjects().offset + rowIndex + 1 }}</span>
      </ng-template>

      <ng-template #tableCellAction let-row="row">
        <div class="subjects-actions">
          <button
            type="button"
            class="btn subjects-action-button"
            (click)="onEditSubject(row)"
            aria-label="แก้ไขรายวิชา"
          >
            <img
              src="assets/media/icons/svg/pencxil.svg"
              class="subjects-action-icon"
              alt=""
              aria-hidden="true"
            />
          </button>

          @if (row.canDelete) {
          <button
            type="button"
            class="btn subjects-action-button"
            (click)="onDeleteSubject(row)"
            aria-label="ลบรายวิชา"
          >
            <img
              src="assets/media/icons/svg/trush.svg"
              class="subjects-action-icon"
              alt=""
              aria-hidden="true"
            />
          </button>
          }
        </div>
      </ng-template>

      <app-datatable
        [datasource]="subjects()"
        [columns]="columns"
        [isLoading]="tableLoading()"
        [limit]="10"
        [showOrder]="false"
        (sortChange)="onSortChange($event)"
      ></app-datatable>

      <app-table-pagination
        [page]="subjects().page"
        [limit]="subjects().limit"
        [total]="subjects().total"
        [totalPage]="subjects().total_page"
        [offset]="subjects().offset"
        [dataLength]="subjects().data.length"
        [pageSizeOptions]="pageSizeOptions"
        ariaLabel="Subjects pagination"
        (pageChange)="onPageChange($event)"
        (limitChange)="onLimitChange($event)"
      ></app-table-pagination>
    </div>
  </div>
</div>

<app-form-import-new
  modalId="subjectsImportDataModal"
  [isSaving]="isImporting"
  (saved)="onImportFile($event)"
></app-form-import-new>
<app-confirm-dialog
  #importSubjectSuccessDialog
  modalId="importSubjectSuccess"
  icon="success"
  title="นำเข้าข้อมูลสำเร็จ"
  message="นำเข้าข้อมูลรายวิชาเรียบร้อยแล้ว"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="importSubjectSuccessDialog.close()"
></app-confirm-dialog>
<app-form-add-subject
  (saved)="onSubjectSaved($event)"
  (saveFailed)="onSubjectSaveFailed($event)"
></app-form-add-subject>
<app-confirm-dialog
  #deleteSubjectConfirmDialog
  modalId="deleteSubjectConfirm"
  title="ยืนยันการลบรายการ"
  message="คุณต้องการลบรายการนี้ใช่หรือไม่ ?"
  cancelText="ยกเลิก"
  confirmText="ยืนยัน"
  [isProcessing]="isDeleting"
  (confirmed)="onConfirmDeleteSubject()"
  (cancelled)="onCancelDeleteSubject()"
></app-confirm-dialog>
<app-confirm-dialog
  #deleteSubjectSuccessDialog
  modalId="deleteSubjectSuccess"
  icon="success"
  title="ลบรายการสำเร็จ"
  message="ลบข้อมูลรายวิชาเรียบร้อยแล้ว"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="deleteSubjectSuccessDialog.close()"
></app-confirm-dialog>
<app-confirm-dialog
  #deleteSubjectErrorDialog
  modalId="deleteSubjectError"
  icon="error"
  title="ไม่สามารถลบรายการได้"
  [message]="deleteSubjectErrorMessage"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="deleteSubjectErrorDialog.close()"
></app-confirm-dialog>
<app-confirm-dialog
  #createSubjectSuccessDialog
  modalId="createSubjectSuccess"
  icon="success"
  title="เพิ่มรายการสำเร็จ"
  message="เพิ่มข้อมูลรายวิชาเรียบร้อยแล้ว"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="createSubjectSuccessDialog.close()"
></app-confirm-dialog>
<app-confirm-dialog
  #createSubjectErrorDialog
  modalId="createSubjectError"
  icon="error"
  title="ไม่สามารถเพิ่มรายการได้"
  [message]="createSubjectErrorMessage"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="createSubjectErrorDialog.close()"
></app-confirm-dialog>
<app-confirm-dialog
  #editSubjectSuccessDialog
  modalId="editSubjectSuccess"
  icon="success"
  title="แก้ไขรายการสำเร็จ"
  message="แก้ไขข้อมูลรายวิชาเรียบร้อยแล้ว"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="editSubjectSuccessDialog.close()"
></app-confirm-dialog>
<app-confirm-dialog
  #editSubjectErrorDialog
  modalId="editSubjectError"
  icon="error"
  title="ไม่สามารถแก้ไขรายการได้"
  [message]="editSubjectErrorMessage"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="editSubjectErrorDialog.close()"
></app-confirm-dialog>
